module.exports = __webpack_public_path__ + "static/img/jxcb612.6fac9ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jxcb612.png
// module id = K0eC
// module chunks = 73